;"use strict";
window.overwatch = window.overwatch || {};
window.overwatch.CountryModel = {

	Mediator: null,
	
	eventNameChange: null,

	current: null,

	$doc: $(document),

	init: function(config) {
		this.Mediator = config.Mediator;
		this.eventNameChange = config.eventNameChange;
		this.current = config.current;
	},

	getCurrent: function() {
		return this.current;
	},

	setCurrent: function(country) {
		this.current = country;
		this._publish();
	},

	_publish: function() {
		this.Mediator.publish(this.eventNameChange, this.current);
	}

};
